var r=function(r){var t=(r=r||{}).max||Number.MAX_SAFE_INTEGER,a=void 0!==r.start?r.start:Math.floor(Math.random()*t);return function(){return a%=t,a++}};export{r as j};
